import React from "react"
import { setNestedObjectValues, useFormikContext } from "formik"
import { useOrder } from "context/order"
import Input from "components/Input"
import MaskedInput from "components/MaskedInput"
import Select from "components/Select"
import Button from "components/Button"

import { useLocale } from "context/locale"

import StyledStepSecond from "./styles"

const options = [
  { value: "Dolnośląskie", label: "Dolnośląskie" },
  { value: "Kujawsko-Pomorskie", label: "Kujawsko-Pomorskie" },
  { value: "Lubelskie", label: "Lubelskie" },
  { value: "Lubuskie", label: "Lubuskie" },
  { value: "Łódzkie", label: "Łódzkie" },
  { value: "Małopolskie", label: "Małopolskie" },
  { value: "Mazowieckie", label: "Mazowieckie" },
  { value: "Opolskie", label: "Opolskie" },
  { value: "Podkarpackie", label: "Podkarpackie" },
  { value: "Podlaskie", label: "Podlaskie" },
  { value: "Pomorskie", label: "Pomorskie" },
  { value: "Śląskie", label: "Śląskie" },
  { value: "Świętokrzyskie", label: "Świętokrzyskie" },
  { value: "Warmińsko-Mazurskie", label: "Warmińsko-Mazurskie" },
  { value: "Wielkopolskie", label: "Wielkopolskie" },
  { value: "Zachodniopomorskie", label: "Zachodniopomorskie" },
]

const StepSecond = () => {
  const { t } = useLocale()

  const { validateForm, setTouched, isValid } = useFormikContext()
  const { step, setStep, checkValidation } = useOrder()

  return (
    <div className="form-step" style={step !== 2 ? { display: "none" } : {}}>
      <StyledStepSecond>
        <h4 className="order-courier-form__subheader">
          {t("Fill in your data that is necessary for the donation to be made")}
        </h4>
        <div className="order-data">
          <div className="row-group">
            <div className="inp-box">
              <Input name="first_name" label={t("Name")} />
            </div>
            <div className="inp-box">
              <Input name="last_name" label={t("Surname")} />
            </div>
            <div className="inp-box">
              <Input name="email" label="E-mail" />
            </div>
          </div>
          <div className="row-group">
            <div className="inp-box">
              <Input name="street" label={t("Full address")} />
            </div>
            <div className="inp-box">
              <Input name="city" label={t("City")} />
            </div>
            <div className="inp-box">
              <Input name="phone" label={t("Phone number")} />
            </div>
          </div>
          <div className="row-group">
            <div className="inp-box">
              <Select
                name="province"
                label={t("Voivodship")}
                options={options}
              />
            </div>
            <div className="inp-box">
              <MaskedInput
                name="postcode"
                label={t("Zip code")}
                mask={[/[0-9]/, /[0-9]/, "-", /[0-9]/, /[0-9]/, /[0-9]/]}
              />
            </div>
          </div>
        </div>
        <div className="order-courier-form__cta">
          <Button
            type="button"
            text={t("Back")}
            variant="prev"
            onClick={() => setStep(1)}
          />
          <Button
            disabled={!isValid}
            type="button"
            text={t("Next")}
            variant="next"
            onClick={async () => {
              const data = await validateForm()
              if (checkValidation(data)) {
                setStep(3)
              } else {
                setTouched(setNestedObjectValues(data, true))
              }
            }}
          />
        </div>
      </StyledStepSecond>
    </div>
  )
}
export default StepSecond
